// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallPreviewLoader__container-fa3185 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  margin: auto;
  box-sizing: border-box;
  position: relative;
  background-color: var(--addition-70);
  border: 1px solid var(--base-20);
  border-radius: 32px;
  width: 100%;
  max-width: 432px;
  height: 100%;
  max-height: 528px;
}

.CallPreviewLoader__logo-a6c8bb {
  margin-top: auto;
}

.CallPreviewLoader__loader-b75142 {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/RoomCallPreviewPopup/CallPreviewLoader/CallPreviewLoader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n  margin: auto;\n  box-sizing: border-box;\n  position: relative;\n  background-color: var(--addition-70);\n  border: 1px solid var(--base-20);\n  border-radius: 32px;\n  width: 100%;\n  max-width: 432px;\n  height: 100%;\n  max-height: 528px;\n}\n\n.logo {\n  margin-top: auto;\n}\n\n.loader {\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CallPreviewLoader__container-fa3185`,
	"logo": `CallPreviewLoader__logo-a6c8bb`,
	"loader": `CallPreviewLoader__loader-b75142`
};
module.exports = ___CSS_LOADER_EXPORT___;
